var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.span && !_vm.isDeleted)?_c('span',{key:_vm.key + _vm.isEditing,staticClass:"tspan",class:{
    unclear: _vm.isUnclear && _vm.span.content.trim().length > 0,
    searchword: _vm.signalType === 'Search Word' && _vm.span.content.trim().length > 0,
    casekw: _vm.signalType === 'Case Keyword' && _vm.span.content.trim().length > 0,
    codeword: _vm.signalType === 'Code Word' && _vm.span.content.trim().length > 0,
    incident: _vm.hasIncident,
    'incident-start': _vm.isIncidentStart,
    'incident-end': _vm.isIncidentEnd,
    incident: _vm.hasIncident,
    redacted: _vm.hasRedaction,
    keyword: _vm.keywordPosition > -1,
    current: _vm.isCurrentKeyword,
    is: _vm.isPlaying || _vm.isFollowing,
    playing: _vm.isPlaying,
    following: _vm.isFollowing,
    insideClip: _vm.isInsideClip,
    'has-change-request': _vm.hasChangeRequest,
    'cursor-pointer': _vm.audioReady || _vm.hasChangeRequest,
    'selected': _vm.isHighlighted,
  },style:(_vm.styleOverrides),attrs:{"id":_vm.side === 'lhs' ? _vm.span.start + 1 : _vm.span.start + 10000001,"data-key":_vm.key,"data-s":_vm.span.start,"data-e":_vm.span.end,"data-d":_vm.isEditing && _vm.differs,"data-o":_vm.span.content,"data-so":_vm.span.startOffset,"data-eo":_vm.span.endOffset,"data-spk":_vm.speakerPos},on:{"click":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"]))return null;if('button' in $event && $event.button !== 0)return null;return _vm.handleClick.apply(null, arguments)},"dblclick":_vm.handleDouble,"input":_vm.onInput,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab"))return null;return _vm.tabup.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.span.content)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }